import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";
import { BaseResponse } from "../_types";

interface IAddMerchantWithTodebInfosRequest {
  id?: number;
  status?: string;
  systemDate?: string;
  createDate?: string;
  createUserId?: number;
  createUserName?: string;
  updateDate?: string;
  updateUserId?: number;
  updateUserName?: string;
  deleteDate?: string | null;
  deleteUserId?: number | null;
  deleteUserName?: string | null;
  merchantType?: number;
  merchantName?: string;
  tradeName?: string;
  foundationDate?: string;
  openingDate?: string;
  aggreementDate?: string;
  closedDate?: string | null;
  taxNumber?: string;
  taxOfficeCode?: string;
  taxOfficeName?: string;
  citizenshipNumber?: string;
  cityId?: number;
  districtId?: number;
  addressLine1?: string;
  addressLine2?: string;
}

type IAddMerchantWithTodebInfosResponse = BaseResponse<any>;

async function addMerchantWithTodebInfos(todebData: any): Promise<IAddMerchantWithTodebInfosResponse> {
  try {
    const formatDate = (dateStr: string): string | undefined => {
      if (!dateStr || dateStr.length !== 8) return undefined;
      const year = dateStr.substring(0, 4);
      const month = dateStr.substring(4, 6);
      const day = dateStr.substring(6, 8);
      return `${year}-${month}-${day}T00:00:00.000Z`;
    };

    const requestData: IAddMerchantWithTodebInfosRequest = {
      id: 0,
      status: "1", // Aktif
      systemDate: new Date().toISOString(),
      createDate: new Date().toISOString(),
      createUserId: 1,
      createUserName: "System",
      updateDate: new Date().toISOString(),
      updateUserId: 1,
      updateUserName: "System",
      merchantType: 1,
      merchantName: todebData.tradeName || todebData.name || "",
      tradeName: todebData.tradeName || "",
      foundationDate: formatDate(todebData.establishmentDate),
      openingDate: formatDate(todebData.establishmentDate),
      aggreementDate: new Date().toISOString(),
      taxNumber: todebData.taxNumber || "",
      taxOfficeCode: todebData.taxOfficeCode || "",
      taxOfficeName: todebData.taxOfficeName || "",
      citizenshipNumber: todebData.tcIdentityNumber || "",
      cityId: parseInt(todebData.addresses?.find((addr: any) => addr.addressType === "2")?.cityCode ||
        todebData.addresses?.find((addr: any) => addr.addressType === "1")?.cityCode || "0"),
      districtId: parseInt(todebData.addresses?.find((addr: any) => addr.addressType === "2")?.districtCode ||
        todebData.addresses?.find((addr: any) => addr.addressType === "1")?.districtCode || "0"),
      addressLine1: todebData.addresses?.find((addr: any) => addr.addressType === "2")?.address ||
        todebData.addresses?.find((addr: any) => addr.addressType === "1")?.address || "",
      addressLine2: todebData.addresses?.find((addr: any) => addr.addressType === "1")?.address || "",
    };

    const response = await axiosInstance.post("/Merchant/AddWithTodebInfos", requestData);
    return response.data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any)?.error;
  }
}

export function useAddMerchantWithTodebInfos() {
  return useMutation<any, Error, any>(
    (data: any) => addMerchantWithTodebInfos(data)
  );
}
